module.exports = __webpack_public_path__ + "static/media/blue-s-35.f97ed457.png";